//問い合わせページ

import { useContext, useEffect } from "react";
import { TextareaAutosize, Select, MenuItem } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { TitleParamContext } from "../../context/TitleContext";
import { JumpPage } from "../../common/Util";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

export interface IFormInputs {
    title: string,
    contents: string,    
}

export type PageParam = {
    title: string,
    contents: string,
}

const schema = Yup.object({
    contents: Yup.string().required("必須項目です。"),
    title: Yup.string().required("必須項目です。"),
}).required();

export const Inquiry = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const titleContext = useContext(TitleParamContext);
    const beforePageParam = location.state as PageParam;

    const { register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            contents: beforePageParam.contents,
            title: beforePageParam.title,
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const onSubmit = async (data: IFormInputs) => {
        JumpPage<PageParam>("Confirmation", { title: data.title, contents: data.contents }, "", navigate);
    };

    useEffect(() => {
        titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "カスタマーサポート", secondSubTitle: "（お問い合わせ）" });
    });

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                        <div className={market["layoutBox-l"]} style={{ alignItems: "center" }} >
                            <div className={market.marketInputTitle}>
                                <h3>お問い合わせジャンル</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="title"
                                    render={({ field }) => (
                                        <Select
                                            sx={{ width: "calc(100% - 20px);" }}
                                            {...field}
                                        >
                                            <MenuItem value={"製品の使用方法について"}>製品の使用方法について</MenuItem>
                                            <MenuItem value={"製品の機能について"}>製品の機能について</MenuItem>
                                            <MenuItem value={"製品説明（デモンストレーション）の依頼"}>製品説明（デモンストレーション）の依頼</MenuItem>
                                            <MenuItem value={"お見積の依頼"}>お見積の依頼</MenuItem>
                                            <MenuItem value={"ライセンスについて"}>ライセンスについて</MenuItem>
                                            <MenuItem value={"カスタマイズの依頼"}>カスタマイズの依頼</MenuItem>
                                            <MenuItem value={"その他"}>その他</MenuItem>
                                        </Select>
                                    )}
                                    defaultValue="製品の使用方法について"
                                    control={control}
                                />
                            </div>
                        </div>

                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputTitle}>
                                <h3>お問い合わせ内容</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="contents"
                                    control={control}
                                    render={({ field }) => (
                                        <TextareaAutosize
                                            {...field}
                                            {...register("contents")}
                                            minRows="8"
                                            maxRows="8"
                                            maxLength={500}
                                            style={{ width: "100%", height: "100%" }}                                            
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={market.marketFooterArea} style={{marginTop:"75px"}}>
                            <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>戻る</button>
                            <button className={market.marketButton} type="submit" disabled={!isValid}>確認</button>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}